import React from "react";
import { useNavigate } from "react-router-dom";

export default function BrandPage() {
  const navigate = useNavigate();

  return (
    <div className="brand-page-shell">
      <style>{brandPageStyles}</style>

      <div className="brand-page-content">
        <div className="brand-image-wrap">
          <img
            src="/brand-page-2026.png"
            alt="Doctor Is In App"
            className="brand-main-image"
          />

          <button
            type="button"
            className="brand-hotspot brand-login-hotspot"
            onClick={() => navigate("/login")}
            aria-label="Login"
          />

          <button
            type="button"
            className="brand-hotspot brand-register-hotspot"
            onClick={() => navigate("/school-registration")}
            aria-label="Register"
          />
        </div>
      </div>
    </div>
  );
}

const brandPageStyles = `
  .brand-page-shell {
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(135deg, #54c9ff 0%, #518ad0 45%, #496cb8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .brand-page-content {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22px;
  }

  .brand-image-wrap {
    position: relative;
    width: min(96vw, 1560px);
  }

  .brand-main-image {
    width: 100%;
    max-height: 94vh;
    object-fit: contain;
    display: block;
    border-radius: 22px;
    box-shadow: 0 20px 50px rgba(0,0,0,.24);
    user-select: none;
    -webkit-user-drag: none;
  }

  .brand-hotspot {
    position: absolute;
    z-index: 10;
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 0;
  }

  .brand-login-hotspot {
    top: 4.8%;
    left: 74.3%;
    width: 9.2%;
    height: 5.8%;
  }

  .brand-register-hotspot {
    top: 4.8%;
    left: 84.6%;
    width: 10.8%;
    height: 5.8%;
  }

  .brand-hotspot:focus-visible {
    outline: 3px solid rgba(0, 179, 210, 0.85);
    border-radius: 14px;
  }

  @media (max-width: 700px) {
    .brand-page-content {
      padding: 12px;
    }
  }
`;